<template>
    <div ref="scoutHelpPopup">
        <transition name="scout-help-fade">
            <div
                v-if="isOpen"
                class="scout-help-popup-overlay"
                data-testid="scout-help-popup-overlay"
                @click.self="close"
            >
                <div class="scout-help-popup" role="dialog" aria-modal="true" aria-labelledby="scout-help-title">
                    <h2 id="scout-help-title" class="scout-help-popup-title">
                        スカウト希望とは、あなたの興味や意向を<br />企業へ直接アピールできる機能です
                    </h2>
                    <img
                        :src="scoutHelpImageSrc"
                        alt="スカウト希望の流れ"
                        class="scout-help-popup-image"
                    />
                    <div class="scout-help-popup-box">
                        <ul class="scout-help-popup-list">
                            <li>ご意向が企業に伝わりスカウトが来やすくなります</li>
                            <li>1社に対して、一度に1求人のスカウト希望が可能です</li>
                            <li>スカウト希望後1週間経過で"スカウト希望期間終了"となり、再度、別の求人へスカウト希望が可能です</li>
                        </ul>
                    </div>
                    <button
                        type="button"
                        class="scout-help-popup-close"
                        data-testid="scout-help-popup-close"
                        @click="close"
                    >
                        閉じる
                    </button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
/**
 * Scout help popup (スカウト希望とは) – explains scout hope feature.
 * Open via ref: this.$refs.scoutHelpPopup.show()
 */
export default {
    name: 'ScoutHelpPopup',
    data() {
        return {
            isOpen: false,
        };
    },
    computed: {
        scoutHelpImageSrc() {
            return require('@/assets/images/Frame 3183.png');
        },
    },
    methods: {
        show() {
            this.isOpen = true;
        },
        close() {
            this.isOpen = false;
            this.$emit('close');
        },
    },
};
</script>

<style scoped>
.scout-help-fade-enter-active,
.scout-help-fade-leave-active {
    transition: opacity 0.2s ease;
}
.scout-help-fade-enter-active .scout-help-popup,
.scout-help-fade-leave-active .scout-help-popup {
    transition: transform 0.2s ease;
}
.scout-help-fade-enter-from,
.scout-help-fade-leave-to {
    opacity: 0;
}
.scout-help-fade-enter-from .scout-help-popup,
.scout-help-fade-leave-to .scout-help-popup {
    transform: scale(0.98);
}

.scout-help-popup-overlay {
    position: fixed;
    inset: 0;
    z-index: 1050;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background-color: rgba(0, 0, 0, 0.5);
}

.scout-help-popup {
    background: #fff;
    border-radius: 0;
    padding: 24px;
    max-width: 480px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    text-align: center;
}

.scout-help-popup-title {
    font-size: 14px;
    font-weight: bold;
    color: #000;
    margin: 0 0 16px;
    line-height: 1.5;
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: keep-all;
}

.scout-help-popup-image {
    display: block;
    max-width: 100%;
    height: auto;
    margin: 0 auto 16px;
}

.scout-help-popup-box {
    background-color: #E7F6F6;
    border-radius: 0;
    padding: 12px 16px;
    margin-bottom: 20px;
    text-align: left;
}

.scout-help-popup-list {
    margin: 0;
    padding-left: 1.2em;
    font-size: 14px;
    color: #000;
    line-height: 1.6;
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: keep-all;
}

.scout-help-popup-list li {
    margin-bottom: 6px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: keep-all;
}

.scout-help-popup-list li:last-child {
    margin-bottom: 0;
}

.scout-help-popup-close {
    font-size: 12px;
    font-weight: bold;
    width: 95px;
    height: 33px;
    background-color: #666;
    color: #fff;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.scout-help-popup-close:hover {
    background-color: #555;
}

@media (max-width: 767px) {
    .scout-help-popup-list {
        font-size: 10px;
    }

    .scout-help-popup-close {
        width: 95px;
    }
}
</style>
